module.exports = __webpack_public_path__ + "img/menu3-2.e8138137.jpg";